if (!customElements.get('image-reveal')) {
  class ImageReveal extends HTMLElement {
    constructor() {
      super();
      
      this.revealType = this.dataset.revealType || 'drag';
      this.overlayImage = this.querySelector('.image-reveal__overlay-image');
      this.revealButton = this.querySelector('.image-reveal__button');
      this.revealSeparator = this.querySelector('.image-reveal__separator');
      this.dataRevealImage = this.dataset.revealImage || 'left';
      
      if (this.revealType === 'scroll') {
        this.setupScrollEvent();
      } else {
        this.setupInputEvent();
      }
    }

    setupInputEvent() {
      this.inputEl = this.querySelector('input[type="range"]');

      this.inputEl.addEventListener('input', () => {
        this.updateImageRevealElements(this.inputEl.value);
      });
    }

    setupScrollEvent() {
      window.addEventListener('scroll', () => {
        const boundingRect = this.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        const startOffset = 0.2;
        const endOffset = 0.7;
        
        let progress = (viewportHeight - boundingRect.top) / (viewportHeight + boundingRect.height);
        progress = (progress - startOffset) / (endOffset - startOffset);
        progress = Math.min(1, Math.max(0, progress));
        
        if (this.dataRevealImage === 'right') {
          progress = 1 - progress;
        }
        
        this.updateImageRevealElements(progress * 100);
      });
    }

    updateImageRevealElements(percentage) {
      const percentValue = `${percentage}%`;

      if (!this.overlayImage || !this.revealButton || !this.revealSeparator) {
        return;
      }

      this.overlayImage.style.width = percentValue;
      this.revealButton.style.left = percentValue;
      this.revealSeparator.style.left = percentValue;
    }
  }

  customElements.define('image-reveal', ImageReveal);
}
